<template>
  <v-container>
    <v-row no-gutters>
      <v-col cols="12">
        <v-flex class="pb-2 ml-3">
          <v-alert
            color="primary"
            text
            icon="mdi-barcode-off"
            type="info"
            border="bottom"
            >PRODUTOS SEM GTIN - EM CONSTRUÇÃO</v-alert
          >
        </v-flex>
      </v-col> </v-row
    ><!--
    <v-card class="padding">
      <v-switch
        v-model="sv"
        :label="filtroProduto"
        color="info"
        hide-details
      ></v-switch>
    </v-card>
    <v-card v-show="!sv">
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Pesquisar"
        filled
        dense
        single-line
        hide-details
      ></v-text-field>

      <v-data-table
        :headers="headers"
        :items="itemsProdutosSgt"
        :loading="loading_table"
        loading-text="Carregando... Aguarde"
        dense
        :search="search"
        no-data-text="Nenhum resultado encontrado!"
        no-results-text="Nenhum resultado encontrado!"
        class="elevation-1"
      >
        <template v-slot:item.action="{ item }">
          <v-icon small class="mr-2" @click="editProduto(item)">edit</v-icon>
        </template>
      </v-data-table>
    </v-card>
    <v-card v-show="sv">
      <v-text-field
        v-model="searchVinculados"
        append-icon="search"
        label="Pesquisar"
        filled
        dense
        single-line
        hide-details
      ></v-text-field>

      <v-data-table
        :headers="headersVinculado"
        :items="itemsProdutosSgtVinculados"
        :loading="loading_table"
        loading-text="Carregando... Aguarde"
        dense
        :search="search"
        no-data-text="Nenhum resultado encontrado!"
        no-results-text="Nenhum resultado encontrado!"
        class="elevation-1"
      >
        <template v-slot:item.action="{ item }">
          <v-icon small class="mr-2" @click="editProduto(item)">edit</v-icon>

          <v-icon
            small
            class="mr-2"
            color="red darken-2"
            @click="desligarProduto(item)"
            >mdi-link-off</v-icon
          >
        </template>
      </v-data-table>
    </v-card>

    <v-dialog v-model="dialog" persistent max-width="450">
      <v-card>
        <v-card-title class>Vincular Produto sem gtin</v-card-title>
        <v-card-text>
          <v-autocomplete
            :items="itemsProdutos"
            label="Selecione um produto"
            solo
            item-text="descricao"
            item-value="cod_prod"
            dense
            v-model="selProduto"
          ></v-autocomplete>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            text
            @click="
              fecharDialog();
              dialog = false;
            "
            >cancela</v-btn
          >
          <v-btn
            color="green darken-1"
            solo
            text
            @click="
              vincularProduto();
              dialog = false;
            "
            >ok</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogVinc" persistent max-width="450">
      <v-card>
        <v-card-title class>Desvincular Produto?</v-card-title>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="dialogVinc = false"
            >cancela</v-btn
          >
          <v-btn color="green darken-1" solo text @click="desVincularProduto()"
            >ok</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>-->
  </v-container>
</template>

<script>
export default {
  props: {
    source: String,
  },
  data: () => ({
    filtroProduto: "Produtos sem Vinculos",
    sv: false,
    dialog: false,
    itemsProdutos: [],
    itemsProdutosSgt: [],
    itemsProdutosSgtVinculados: [],
    search: "",
    searchVinculados: "",
    loading_table: false,
    selProduto: "",
    itemEdit: "",
    dialogVinc: false,
    headers: [
      {
        text: "cod_prod",
        align: "left",
        value: "cod_prod",
      },
      {
        text: "Produto",
        value: "descricao",
        sortable: true,
        align: "left",
      },
      {
        text: "UN",
        value: "un",
        align: "left",
      },
      { text: "Ação", value: "action", sortable: false },
    ],
    headersVinculado: [
      {
        text: "cod_prod",
        align: "left",
        value: "cod_prod",
      },
      {
        text: "Produto",
        value: "descricao",
        sortable: true,
        align: "left",
      },
      {
        text: "UN",
        value: "un",
        align: "left",
      },
      {
        text: "Produto Vinculado",
        value: "xProdVenda",
        sortable: true,
        align: "left",
      },
      {
        text: "Codigo Barras",
        value: "cEANTrib",
        sortable: true,
        align: "left",
      },
      { text: "Ação", value: "action", sortable: false },
    ],
  }),
  watch: {
    sv(val) {
      if (val === true) {
        this.filtroProduto = "Produtos vinculados";
        this.buscaProdutosSgtVinc();
      } else {
        this.filtroProduto = "Produtos sem Vinculo";
      }
    },
  },
  mounted() {
    this.buscaProdutosSgt();
    this.buscaProdutos();
  },
  methods: {
    fecharDialog() {},
    desligarProduto(item) {
      this.dialogVinc = true;
      this.itemEdit = item.id;
    },
    editProduto(item) {
      this.dialog = true;
      this.itemEdit = item.id;
    },
    desVincularProduto() {
      this.dialogVinc = false;

      axios
        .post(`/produtos/desvincula`, {
          id_cliente: window.sessionStorage.getItem("cnpj"),
          id_produto: this.itemEdit,
        })
        .then((response) => {
          if (response.data.error) {
            //  this.textSnack = response.data.error;
            //  this.snackbar = true;
          } else {
            this.buscaProdutosSgtVinc();
            this.itemEdit = "";
          }
        });
    },
    vincularProduto() {
      axios
        .post(`/produtos/vincula`, {
          id_cliente: window.sessionStorage.getItem("cnpj"),
          id_produto: this.itemEdit,
          produto_vinc: this.selProduto,
        })
        .then((response) => {
          if (response.data.error) {
            //  this.textSnack = response.data.error;
            //  this.snackbar = true;
          } else {
            this.buscaProdutosSgt();
            this.itemEdit = "";
            this.selProduto = "";
          }
        });
    },

    buscaProdutosSgt() {
      axios
        .post(`/produtos/semgtin/lista`, {
          id_cliente: window.sessionStorage.getItem("cnpj"),
        })
        .then((response) => {
          if (response.data.error) {
            //  this.textSnack = response.data.error;
            //  this.snackbar = true;
          } else {
            // this.loading_table = false;
            //this.loading_filtrar = false;
            this.itemsProdutosSgt = response.data;
          }
        });
    },
    buscaProdutosSgtVinc() {
      axios
        .post(`/produtos/semgtin_vinc/lista`, {
          id_cliente: window.sessionStorage.getItem("cnpj"),
        })
        .then((response) => {
          if (response.data.error) {
            //  this.textSnack = response.data.error;
            //  this.snackbar = true;
          } else {
            // this.loading_table = false;
            //this.loading_filtrar = false;
            this.itemsProdutosSgtVinculados = response.data;
          }
        });
    },
    buscaProdutos() {
      axios
        .post(`/produtos/lista`, {
          id_cliente: window.sessionStorage.getItem("cnpj"),
        })
        .then((response) => {
          if (response.data.error) {
            //  this.textSnack = response.data.error;
            //  this.snackbar = true;
          } else {
            // this.loading_table = false;
            //this.loading_filtrar = false;
            this.itemsProdutos = response.data;
          }
        });
    },
  },
};
</script>
<style scoped>
.v-input--selection-controls {
  padding: 5px !important;
  margin-bottom: 5px !important;
  margin-top: 16px;
  padding-top: 4px;
}
.v-data-table td {
  font-size: 0.685rem !important;
}
</style>